/* script */
//
//
//
//

import { TOAST_EVENT } from "../../composables/useToast";

/**
 * Toaster — the single $bvToast renderer for the app.
 *
 * Mounted on every page by the toaster pack. Producers in other packs cannot
 * share module state with this bundle (isolated iife packs), so they dispatch
 * TOAST_EVENT CustomEvents via useToast(); this component listens on document
 * and renders each payload with $bvToast. VNode bodies (paragraph arrays,
 * permission-denied admin lists) are built here, where a component render
 * context exists — useToast payloads stay plain data.
 *
 * Also renders Rails flash messages passed as props from the layout.
 */
const __vue_script__ = {
  name: "Toaster",
  props: {
    notice: {
      type: String,
      required: false,
    },
    alert: {
      type: String,
      required: false,
    },
  },
  created: function () {
    this.onToastEvent = (event) => this.renderToast(event.detail);
    document.addEventListener(TOAST_EVENT, this.onToastEvent);
  },
  mounted: function () {
    if (this.notice) {
      this.renderToast({ title: "Notice", variant: "success", message: [this.notice] });
    }

    if (this.alert) {
      this.renderToast({ title: "Error", variant: "danger", message: [this.alert] });
    }
  },
  beforeDestroy: function () {
    document.removeEventListener(TOAST_EVENT, this.onToastEvent);
  },
  methods: {
    // Render one toast payload ({title, variant, message, admins?, autoHideDelay?}).
    renderToast: function ({ title, variant, message, admins, autoHideDelay }) {
      let body = message;
      if (admins) {
        body = this.permissionDeniedBody(message, admins);
      } else if (Array.isArray(message)) {
        body = this.arrayToMessage(message);
      }

      const options = { title: title, variant: variant, solid: true };
      if (autoHideDelay) {
        options.autoHideDelay = autoHideDelay;
      }
      this.$bvToast.toast(body, options);
    },
    // Takes an array of messages and forms them into a nicely formatted toast message
    arrayToMessage: function (messageArray) {
      return this.$createElement(
        "div",
        messageArray.map((message) => this.$createElement("p", message)),
      );
    },
    // Build a VNode body for a structured permission_denied response.
    // Renders the message paragraph followed by a "Project administrators:"
    // section listing each admin as "Name <email>" — so the user knows
    // exactly who to contact for access.
    permissionDeniedBody: function (message, admins) {
      const h = this.$createElement;
      const children = [h("p", { class: "mb-2" }, message)];
      if (admins.length > 0) {
        children.push(
          h("p", { class: "mb-1 font-weight-bold" }, "Project administrators:"),
          h(
            "ul",
            { class: "mb-0 pl-3" },
            admins.map((a) => h("li", `${a.name} <${a.email}>`)),
          ),
        );
      }
      return h("div", children);
    },
  },
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div")
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-ac3c61b2_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"Toaster.vue"}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-ac3c61b2"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "app/javascript/components/toaster/Toaster.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__